import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';
const useDecommisionTME = () => useIsFeatureFlagEnabled('decomissionTme');
export default useDecommisionTME;
